import type { GuestList } from "@/lib/api";

/**
 * Reserved guest-list name: guests here are "not yet on a table" and use status "Bez stola".
 * This list is hidden from the main accordion; guests still appear under "Svi gosti".
 */
export const UNASSIGNED_GUEST_LIST_NAME = "Bez stola";

export function isUnassignedGuestList(
  list: Pick<GuestList, "attributes" | "name"> | GuestList
): boolean {
  const n = (list.attributes?.name ?? list.name ?? "").trim();
  return n === UNASSIGNED_GUEST_LIST_NAME;
}

/** Keep the reserved list last so manual order applies only to "real" tables. */
export function pinUnassignedGuestListLast(lists: GuestList[]): GuestList[] {
  const tail = lists.filter((l) => isUnassignedGuestList(l));
  const rest = lists.filter((l) => !isUnassignedGuestList(l));
  return [...rest, ...tail];
}
